import { dispatchAction } from '@ardoq/rxbeach';
import { COMPONENT_ID_ATTRIBUTE } from '@ardoq/global-consts';
import { GLOBAL_HANDLER_ID_ATTRIBUTE, GLOBAL_MODEL_SELECTORS } from 'consts';
import {
  getComponentIds,
  getReferenceIds,
} from 'modelElements/modelElementIds';
import { presentationModelElementDoubleClicked } from './actions';

/** the document double-click handler for the presentation viewer. */
const documentDoubleClickHandler = (event: MouseEvent) => {
  const target = event.target as Element | null;
  const element = target?.closest(GLOBAL_MODEL_SELECTORS.join(', ')) || null;

  if (
    !target ||
    !element ||
    !element.matches(GLOBAL_MODEL_SELECTORS.join(', ')) ||
    element.closest('.react-view')
  ) {
    return;
  }

  dispatchAction(
    presentationModelElementDoubleClicked({
      elementModelId:
        element.getAttribute(GLOBAL_HANDLER_ID_ATTRIBUTE) ||
        element.getAttribute(COMPONENT_ID_ATTRIBUTE),
      componentIds: getComponentIds(target),
      referenceIds: getReferenceIds(element),
    })
  );

  event.stopImmediatePropagation();
  return false;
};
export { documentDoubleClickHandler };
